(function ($) {
	// LMSG Toast Controller
	// Controls ingestion, queue, display, and list-mode for toast messages
	$(document).ready(function () {
		const SEL = {
			container: '#lmsg-f',
			sources: '.lmsg-f',
			toast: '> div', // each direct child is a toast
			closeBtn: '.lmsg-c',
			listToggle: '#lmsg-list-mode',
			timer: '.lmsg-t'
		};

		// Ensure container exists
		let $container = $(SEL.container);
		if ($container.length === 0) {
			$container = $('<div id="lmsg-f" aria-live="polite" aria-atomic="true"></div>').appendTo('body');
		}

		// Mark JS control
		$container.addClass('lmsg-js');

		// State
		const state = {
			queue: [], // pending toasts (DOM elements)
			active: null, // current active toast (jQuery element)
			inListMode: false,
			timers: {
				activeTimer: null,
			},
			ids: 0
		};

		// Read default time from CSS var :root --lmsg-default-time
		function readCssDurationMs($el) {
			// Read --time then fallback to root var
			const el = $el && $el[0] ? $el[0] : document.documentElement;
			const cs = getComputedStyle(el);
			const val = cs.getPropertyValue('--time') || cs.getPropertyValue('--lmsg-default-time') || '5s';
			return parseTimeToMs(val.trim());
		}

		function parseTimeToMs(str) {
			if (!str) return 5000;
			// supports "ms" and "s"
			if (str.endsWith('ms')) return parseFloat(str);
			if (str.endsWith('s')) return parseFloat(str) * 1000;
			const n = parseFloat(str);
			return isNaN(n) ? 5000 : n; // assume ms if unitless
		}

		function setToastState($toast, add, remove) {
			if (!$toast || $toast.length === 0) return;
			if (remove) $toast.removeClass(remove);
			if (add) $toast.addClass(add);
		}

		function ensureToastIdentity($toast) {
			if (!$toast.attr('data-lmsg-id')) {
				state.ids += 1;
				$toast.attr('data-lmsg-id', String(state.ids));
			}
		}

		function normalizeToast($toast) {
			ensureToastIdentity($toast);
			// Reset interaction states
			$toast.removeClass('is-active is-closing').removeClass('lmsg-done').css({ '--offset': '0s' });
			// Hide by default under JS mode
			$toast.hide().css({ opacity: '', transform: '' });
			// Pause timer ring by default (only active toast runs)
			// Achieved via hidden/display none; CSS animation won't run when hidden.
		}

		function enqueue($toast) {
			if (!$toast || $toast.length === 0) return;
			normalizeToast($toast);
			if (state.inListMode) {
				// In list mode we immediately show it at the top (history), not in queue
				addToListMode($toast);
				return;
			}
			state.queue.push($toast);
			tryActivateNext();
		}

		function tryActivateNext() {
			if (state.inListMode) return; // no activation during list mode
			if (state.active) return;
			const next = state.queue.shift();
			if (!next) return;
			activate(next);
		}

		function activate($toast) {
			state.active = $toast;
			// Ensure base hidden state (no active/closing), visible display but with initial styles
			$toast.removeClass('is-active is-closing lmsg-done');
			$toast.css('display', 'block'); // show without toggling classes yet
			// Reset offset to start counter now
			$toast[0].style.setProperty('--offset', '0s');
			// Force reflow so transitions will run on next state change
			void $toast[0].offsetWidth;
			// Activate on next frame to trigger CSS transition
			requestAnimationFrame(() => {
				setToastState($toast, 'is-active', '');
				// Start auto-dismiss timer synced with CSS var
				const dur = readCssDurationMs($toast);
				clearActiveTimer();
				state.timers.activeTimer = setTimeout(() => {
					closeActive('timeout');
				}, dur);
			});
		}

		function clearActiveTimer() {
			if (state.timers.activeTimer) {
				clearTimeout(state.timers.activeTimer);
				state.timers.activeTimer = null;
			}
		}

		function closeActive(reason) {
			if (!state.active) return;
			const $cur = state.active;
			state.active = null;
			clearActiveTimer();

			// Transition to closing, then archive after 500ms
			setToastState($cur, 'is-closing', 'is-active');
			// Ensure it remains visible during closing animation
			$cur.show();
			// Show next immediately while this one fades out
			tryActivateNext();
			setTimeout(() => {
				archiveToast($cur);
			}, 500);
		}

		function archiveToast($toast) {
			// Mark as done and hide from normal mode
			setToastState($toast, 'lmsg-done', 'is-active is-closing');
			$toast.hide();
		}

		function addToListMode($toast) {
			ensureToastIdentity($toast);
			// Mark as done (historico) e garantir exibição no modo lista
			$toast.removeClass('is-active is-closing').addClass('lmsg-done').show();
			// Inserir como primeiro (mais recente no topo)
			$container.prepend($toast);
		}

		function enterListMode() {
			if (state.inListMode) return;
			state.inListMode = true;
			$container.addClass('lmsg-list-mode');
			// Cancel active and archive it
			if (state.active) {
				const $cur = state.active;
				state.active = null;
				clearActiveTimer();
				archiveToast($cur);
			}
			// Move all pending into archive (become visible in list mode)
			while (state.queue.length) {
				const $t = state.queue.shift();
				archiveToast($t);
			}
			// Reveal all toasts inside container (list mode CSS ensures visibility)
			$container.children().each(function () {
				$(this).show();
			});
			// Create a real clickable overlay for the pseudo close if not exists
			if ($container.find('[data-lmsg-list-close]').length === 0) {
				$('<button type="button" class="lmsg-list-close" data-lmsg-list-close aria-label="Fechar histórico">x</button>').appendTo($container);
			}
			// Reorder by newest first (higher data-lmsg-id on top)
			const items = $container.children('div').get();
			items.sort((a, b) => {
				const ida = parseInt(a.getAttribute('data-lmsg-id') || '0', 10);
				const idb = parseInt(b.getAttribute('data-lmsg-id') || '0', 10);
				return idb - ida; // desc
			});
			items.forEach(el => $container.append(el));
			// Scroll to top to show the most recent first
			$container.scrollTop(0);
		}

		function exitListMode() {
			if (!state.inListMode) return;
			state.inListMode = false;
			$container.removeClass('lmsg-list-mode');
			// After closing list mode, nothing replays. Wait for new toasts only.
			// All archived stay hidden (outside list mode); ensure hidden
			$container.children().each(function () {
				const $t = $(this);
				if ($t.hasClass('lmsg-done')) $t.hide();
			});
			// Hide close overlay if present
			$container.find('[data-lmsg-list-close]').hide();
		}

		// Hover pause/resume on container for active toast timer
		$container.on('mouseenter', function () {
			// Pause only when not in list mode
			if (!state.inListMode && state.active) {
				clearActiveTimer();
			}
		});
		$container.on('mouseleave', function () {
			if (!state.inListMode && state.active) {
				// Resume with remaining time is complex without tracking elapsed.
				// Simpler: restart timer with remaining computed from CSS ring progress is non-trivial.
				// Tradeoff: restart with a small grace (e.g., 1s) or full time.
				// Here: restart with remaining using dataset if tracked; otherwise full duration.
				const $active = state.active;
				if ($active) {
					// No tracking elapsed yet; restart full duration to keep behavior simple.
					const dur = readCssDurationMs($active);
					clearActiveTimer();
					state.timers.activeTimer = setTimeout(() => closeActive('timeout'), dur);
				}
			}
		});

		function findToastFromButton(btnEl) {
			// climb up until the direct child of container (#lmsg-f)
			let $el = $(btnEl).closest('div');
			while ($el.length && !$el.parent().is($container)) {
				$el = $el.parent();
			}
			return $el;
		}

		// Delegate close button (works for any .lmsg-c inside #lmsg-f toasts)
		$container.on('click', SEL.closeBtn, function (e) {
			e.preventDefault();
			e.stopPropagation();

			const $t = findToastFromButton(this);
			if (!$t || !$t.length) return;

			if (state.inListMode) {
				// In list mode, closing a toast just hides it from history
				archiveToast($t);
			} else if (state.active && $t.is(state.active)) {
				closeActive('manual');
			} else {
				// If it's not active (should be hidden), ensure it doesn't block clicks
				archiveToast($t);
			}
		});

		// Toggle list mode button
		$(document).on('click', SEL.listToggle, function (e) {
			e.preventDefault();
			if ($container.hasClass('lmsg-list-mode')) {
				exitListMode();
			} else {
				enterListMode();
			}
		});

		// Clicking in the top-right "X" pseudo-element is not directly capturable; optionally provide a real close if present
		// If a real element with role exists (e.g., button[data-lmsg-list-close])
		$container.on('click', '[data-lmsg-list-close]', function (e) {
			e.preventDefault();
			exitListMode();
		});

		// Ingest initial .lmsg-f wrappers and direct toasts
		function ingestExisting() {
			// Move children of any .lmsg-f into container
			$(SEL.sources).each(function () {
				const $src = $(this);
				const children = $src.children();
				if (children.length) {
					children.appendTo($container);
				}
				$src.remove();
			});

			// Normalize container children and enqueue
			$container.children().each(function () {
				const $t = $(this);
				// Ensure it's element node
				if (this.nodeType !== 1) return;
				if (!$t.is('div')) return; // expect div toasts
				if ($t.closest(SEL.container).length === 0) return;
				// Only enqueue if not already archived
				if ($t.hasClass('lmsg-done')) return;
				enqueue($t);
			});
		}

		ingestExisting();

		// MutationObserver for dynamic additions
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((m) => {
				// New .lmsg-f wrappers
				$(m.addedNodes).each(function () {
					if (this.nodeType !== 1) return;
					const $node = $(this);
					if ($node.is(SEL.sources)) {
						const children = $node.children();
						if (children.length) {
							children.appendTo($container);
						}
						$node.remove();
						// Enqueue moved children
						children.each(function () { enqueue($(this)); });
					} else if ($node.closest(SEL.container).length) {
						// Node added under #lmsg-f directly
						if ($node.parent()[0] === $container[0]) {
							const $t = $node;
							if (!$t.hasClass('lmsg-done')) {
								enqueue($t);
							}
						}
					} else if ($node.find(SEL.sources).length) {
						// Nested .lmsg-f inside subtree
						$node.find(SEL.sources).each(function () {
							const $src = $(this);
							const children = $src.children();
							if (children.length) {
								children.appendTo($container);
								children.each(function () { enqueue($(this)); });
							}
							$src.remove();
						});
					}
				});
			});
		});

		observer.observe(document.body, { childList: true, subtree: true });
	});
})(jQuery);